export default __webpack_public_path__ + "static/media/chatSupportIcon2.4527e636.svg";